<template>
  <section>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <br />
    <div class="box  is-light wdt">
      <!-- <div class="shdw is-paddingless wdt ubuntu" style=""> -->
      <div class="tile is-parent is-vertical centered field">
        <div class="image">
          <!-- <p class="krungthrep" style="text-align: center;">
            <span class="trip">Trip </span> <span class="circuit">Circuit</span>
          </p> -->
          <img src="/images/TC wired for Gant Travel.png" />
        </div>
        <br />
        <b-field v-if="!emailValid"
          placeholder="Email"
          label="Enter your work email to get started"
        >
          <b-input
            v-model="email"
            @keyup.native.enter="getData"
            data-test="email_input"
            placeholder="Email"
            name="email"
            type="email"
          ></b-input>
        </b-field>
        <b-field
          v-if="!emailValid"
          placeholder="Join code"
          label="Have a join code? Enter it below"
        >
          <b-input
            v-model="joinCode"
            type="text"
            name="join-code"
            placeholder="Join code"
          />
        </b-field>

        <b-message
          v-if="registrationMessage"
          type="is-danger"
          aria-close-label="Close message"
          data-test="error_message"
        >
          {{ registrationMessage }}

        </b-message>

        <b-notification
                  type="is-danger is-light"
                  class="my-3"
                  v-if="validationErrors.length > 0"
                >
                  <h4 class="is-size-5">
                    Please correct the following errors:
                  </h4>
                  <div class="content">
                    <ul>
                      <li
                        v-for="(validationError, index) in validationErrors"
                        :key="index"
                      >
                        {{ validationError }}
                      </li>
                    </ul>
                  </div>
                </b-notification>
        <b-button
          v-if="!emailValid"
          size="is-medium"
          type="is-gant"
          class="ubuntu"
          data-test="login_button"
          @click="checkEmail"
          expanded
          :disabled="!isEmailFilled"
        >
          <h5>Submit</h5>
        </b-button>
        <div v-if="emailValid">

          <b-message
          v-if="accountName"
          type="is-info"
        >
          Please complete your profile to join <b>{{ accountName }}</b>. If this is not the organization you wish to join, please <a href="/register">restart your registration.</a>

        </b-message>
      
          <div class="columns is-mobile">
                  <div class="column sect">
                    <div class="columns">
                      <div class="column is-4">
                        <section>
                          <b-field label="First Name">
                            <b-input
                              v-model="user.firstName"
                              required
                              validation-message="Please enter a valid name"
                              pattern="[a-zA-Z]*"
                            ></b-input>
                          </b-field>
                        </section>
                      </div>
                      <div class="column is-4">
                        <section>
                          <b-field label="Middle Name">
                            <b-input
                              v-model="user.middleName"
                              pattern="[a-zA-Z]*"
                            ></b-input>
                          </b-field>
                        </section>
                      </div>
                      <div class="column is-4">
                        <section>
                          <b-field label="Last Name">
                            <b-input
                              v-model="user.lastName"
                              required
                              validation-message="Please enter a valid name"
                              pattern="[a-zA-Z]*"
                            ></b-input>
                          </b-field>
                        </section>
                      </div>
                    </div>

                    <div class="columns">
                      <div class="column is-4">
                        <section>
                          <b-field label="Date of Birth">
                            <b-input
                              v-model="user.dob"
                              v-cleave="masks.dob"
                              required
                              placeholder="mm/dd/yyyy"
                            />
                          </b-field>
                        </section>
                      </div>
                      <div class="column is-4">
                        <section>
                          <b-field label="Gender">
                            <b-select
                              v-model="user.gender"
                              required
                              placeholder="Select Gender"
                              expanded
                            >
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                              <option value="X">Non-Binary</option>
                            </b-select>
                          </b-field>
                        </section>
                      </div>
                      <div class="column is-4">
                        <section>
                          <b-field label="Mobile Phone">
                            <b-input
                              required
                              v-model="user.mobilePhone"
                              v-cleave="masks.phone"
                            ></b-input>
                          </b-field>
                        </section>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <section>
                          <b-field label="Email">
                            <b-input
                              v-model="email"
                              readonly
                              disabled
                              type="email"
                            />
                          </b-field>
                        </section>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <section>
                          <password-input label="Password" :password-value.sync="user.password" />
                        </section>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <section>
                          <password-input label="Confirm Password" />
                        </section>
                      </div>
                    </div>
                  </div>
                </div>

      <b-button
          v-if="emailValid"
          size="is-medium"
          type="is-gant"
          class="ubuntu"
          data-test="login_button"
          @click="registerUser"
          expanded
        >
          <h5>Register</h5>
        </b-button>
      
      </div>


       
        <div class="my-4">
          <p class="text-center register ubuntu">
            Already have an account?
            <a
              href="/login"
              id="signup"
              class="teal-text"
              >Login</a
            >
          </p>
        </div>

        <br />
      </div>
    </div>
    <br />
  </section>
</template>

<script>

import Cleave from "cleave.js";
import PasswordInput from '../components/FormComponents/PasswordInput.vue';


const cleave = {
  name: "cleave",
  bind(el, binding) {
    const input = el.querySelector("input");
    input._vCleave = new Cleave(input, binding.value);
  },
  unbind(el) {
    const input = el.querySelector("input");
    input._vCleave.destroy();
  },
};

export default {
  directives: { cleave },

  name: "Register",
  components: {
    PasswordInput,
  },
  data: function() {
    return {
      email: "",
      emailValid: false,
      loading: false,
      registrationId: null,
      accountName:'',
      masks: {
        phone: {
          phone: true,
          phoneRegionCode: "US",
          delimiter: "-",
        },
        dob: {
          date: true,
          delimiter: "/",
          datePattern: ["m", "d", "Y"],
        },
      },
      user: {
        firstName: "",
        middleName: "",
        lastName: "",
        gender: "",
        mobilePhone: "",
        dob: "",
        password:"",
      },
      validationErrors: [],
      registrationMessage: "",
      joinCode: "",
    };
  },
  methods: {

    validateForm() {
      var errors = [];
      if (!this.user.firstName) {
        errors.push("First name is required");
      }
      if (!this.user.lastName) {
        errors.push("Last name is required");
      }
     
      if (!this.user.gender) {
        errors.push("Gender is required");
      }
      if (!this.user.mobilePhone) {
        errors.push("Mobile phone is required");
      }
      if (!this.user.dob) {
        errors.push("Date of birth is required");
      }
      this.validationErrors = errors;

      if (errors.length > 0) {
        return false;
      }

      return true;
    },

    async checkEmail() {
      this.loading = true;

      const ipAddressResponse = await fetch("https://api.ipify.org?format=json");
    const ipAddressData = await ipAddressResponse.json(); 
    const userIpAddress = ipAddressData.ip; 
    

      console.log("check email is valid");
      var body = {
        email: this.email,
        ip_address: userIpAddress,
      };

      let url = "profile/register/check-email";

      if (this.joinCode) {
        body.join_code = this.joinCode;
        url = "profile/register/check-join-code";
      }

      this.$app
        .huddleLabsServerCall(url, body)
        .then((result) => {
          if (result.valid) {
            this.loading = false;
            this.emailValid = true;

            this.registrationId = result.registrationId;
            this.accountName=result.account;
            this.registrationMessage = "";

          } else {
            this.loading = false;

            this.registrationMessage = "You cannot register with this email.";
            this.accountName='';

          }
        }).catch((error) => {
            this.loading = false;

            this.failure(error);

            console.log(error);
          });
    },

    async registerUser() {

      this.validateForm();

      if (this.validateForm()) {
        this.loading = true;

        this.user.email=this.email;
        const body = {
          user: this.user,
          registrationId: this.registrationId,
        };


        this.$app
        .huddleLabsServerCall("profile/register/create-profile", body)
        .then((result) => {
          if (result.success) {
            this.loading = false;
            this.$router.push("/register/email/check");
           // this.success();

          } else {
            this.loading = false;

            this.failure(result.error_message);
          }
        }).catch((error) => {
            this.loading = false;

            this.failure(error);

            console.log(error);
          });

  

      }
    },

    success() {
      this.$buefy.toast.open({
        message: "Registration successful! Check your email to confirm your email address.",
        type: "is-success",
      });
    },
    failure(msg = "") {
      this.$buefy.toast.open({
        duration: 5000,
        message: "Error occured while registering" + msg,
        position: "is-bottom",
        type: "is-danger",
      });
    },

  },
  created() {


      var joinCode=this.$route.params.joinCode;
      if(joinCode){
        this.joinCode=joinCode;
      }
    
  },
  mounted() {},
  computed: {
    isEmailFilled() {
      return this.email != "";
    },
  },
};
</script>

<style scoped>
.image {
  margin: 0 auto;
  padding: 15px;
  width:50%;
  text-align: center;
  display: block;
}

.trip {
  color: #292c58;
  font-family: Krungthep;
  font-size: 50px;
}

.circuit {
  color: #00aa9c;
  font-family: Krungthep;
  font-size: 50px;
}

.text-center {
  text-align: center;
}

.centered {
  margin: auto;
}

.field {
  border-radius: 5px;
}

.wdt {
  width: 700px !important;
  margin: auto;
  /* background-color: #F5F0E1; */
}

.register {
  background-color: #ddd;
  /* background-color: #F5F0E1; */
  border-radius: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.conditions {
  font-size: 13px;
  color: #292c58;
}

.btn {
  background-color: #292c58;
}

.shdw {
  box-shadow: 0 2px 4px 0 rgba(245, 240, 225, 0.8),
    0 6px 20px 0 rgba(245, 240, 225, 0.8);
  border-radius: 5px;
}

.fade {
  opacity: 0.5;
  transition: opacity 0.05s ease-in-out;
  -moz-transition: opacity 0.05s ease-in-out;
  -webkit-transition: opacity 0.05s ease-in-out;
}

.fade:hover {
  opacity: 1;
}

@media screen and (max-width: 1023px) {
  .wdt {
    width: 100%;
    margin: auto;
    /* background-color: #F5F0E1; */
  }
}

@media screen and (min-width: 1024px) {
  .wdt {
    width: 700px;
    margin: auto;
    /* background-color: #F5F0E1; */
  }
}
</style>
